import { IAmountByCategory } from "@/types/amount_by_category";

export class AmountByCategory implements IAmountByCategory {
  public category_id = 0;
  public name = "";
  public amount = 0;
}
